export default __webpack_public_path__ + "static/media/press_5.da5ab630.jpg";